import { Injectable } from '@angular/core';

import { ApKeyOverridePipe } from './key-override.pipe';

/**
 * @ngdoc service
 * @name ApContentKeyMapService
 * @module ApContentModule
 *
 * @description
 * This service is used together with {@link ApKeyOverridePipe} for content mapping.
 * The service has support for nested components, who want to chain keyMaps from parent to child to grand-child
 */
@Injectable()
export class ApContentKeyMapService {
    /**
     * @ngdoc method
     * @name ApContentKeyMapService#createContentKeyMap
     * @methodOf ApContentKeyMapService
     *
     * @description Returns a map which can be used to overwrites the default content keys of components.
     * The prefix is replaced by a target prefix, and a map with new keys for the components is returned.
     *
     * @param source
     * The original content key prefix
     *
     * @param target
     * The prefix used for the target keys
     *
     * list of additional content post-fixes, usually coming from custom validators
     *
     * @param fields
     * The fields that the prefix is mapped to.
     *
     * @param [map=undefined]
     * maps the resulting target keys one level deeper.
     */
    public createContentKeyMap(
        source: string,
        target: string,
        fields: string[],
        map?: { [key: string]: string }
    ): { [key: string]: string } {
        const keyOverride = new ApKeyOverridePipe();

        const _toKeyMap = (keyMap: { [key: string]: string }, field: string): { [key: string]: string } => {
            keyMap[`${source}.${field}`] = keyOverride.transform(`${target}.${field}`, map);
            return keyMap;
        };

        return fields.reduce(_toKeyMap, {});
    }
}
